import React, { FC } from 'react';

import { Route, Routes } from 'react-router-dom';

import { FilterRouter } from 'components/FilterView';
import { ActiveResourceProvider } from 'containers/ActiveCloudResource/hooks/context/ActiveResourceProvider';
import { useInjector } from 'utils/inject';

import { CloudEvents } from './Components/CloudEvents';
import { ActivityGraphPage } from './Components/Data/Activity/ActivityGraphPage';
import { ActivityGroupResources } from './Components/Data/ActivityGroups/ActivityGroupResources';
import { ActivityGroupForm } from './Components/Data/ActivityGroups/ActivityGroupWizard/ActivityGroupForm';
import { EditActivityGroupForm } from './Components/Data/ActivityGroups/ActivityGroupWizard/UpdateActivityGroup';
import { AggregatedCloudEventsForResource } from './Components/Data/ActivityGroups/AggregatedCloudEventsForResource';
import { CloudEventsForResource } from './Components/Data/ActivityGroups/CloudEventsForResource';
import { incidentResponseSaga } from './saga';
import { reducer, sliceKey } from './slice';

export const IncidentResponse: FC = () => {
  useInjector(sliceKey, reducer, incidentResponseSaga);

  return (
    <Routes>
      <Route element={<FilterRouter path="/visibility/activity/group/add" />}>
        <Route path="group/add" element={<ActivityGroupForm />} />
      </Route>
      <Route
        element={
          <FilterRouter path="/visibility/activity/group/edit/:group_id" />
        }
      >
        <Route
          path="group/edit/:group_id"
          element={<EditActivityGroupForm />}
        />
      </Route>
      <Route
        element={<FilterRouter path="/visibility/activity/group/:group_id" />}
      >
        <Route path="group/:group_id" element={<ActivityGroupResources />} />
      </Route>
      <Route
        element={
          <FilterRouter path="/visibility/activity/group/:group_id/resource/:resource_id/events" />
        }
      >
        <Route
          path="group/:group_id/resource/:resource_id/events"
          element={<CloudEventsForResource />}
        />
      </Route>
      <Route
        element={
          <FilterRouter path="/visibility/activity/group/:group_id/resource/:resource_id" />
        }
      >
        <Route
          path="group/:group_id/resource/:resource_id"
          element={<AggregatedCloudEventsForResource />}
        />
      </Route>
      <Route element={<FilterRouter path="/visibility/activity" />}>
        <Route
          path="graph"
          element={
            <ActiveResourceProvider>
              <ActivityGraphPage />
            </ActiveResourceProvider>
          }
        />
        <Route
          index
          element={
            <ActiveResourceProvider>
              <CloudEvents />
            </ActiveResourceProvider>
          }
        />
      </Route>
    </Routes>
  );
};
